export default __webpack_public_path__ + "static/media/logo-white.36cc779f.png";